<template>
    <!--
    Selection component

    @param [Object, Array] Selection, selected items
    @param [Object, Array] Collection, collection of items
    @param {String} identifier, identifier to map all items from collection to selection
    -->
    <p class="selection">
        {{ count(selection) }} {{ $t('text.of') }} {{ count(collection) }} | {{ $t('text.selection.select') }}
        <a href="#" @click.prevent="selectAll">{{ $t('text.selection.all') }}</a>
        {{ $t('text.or') }}
        <a href="#" @click.prevent="selectNone">{{ $t('text.selection.none') }}</a>
    </p>
</template>

<script>
export default
{
    name: 'Selection',

    props:
    {
        collection:
        {
            type: [Object, Array],
            required: true,
        },

        selection:
        {
            type: [Object, Array],
            required: true,
        },

        identifier:
        {
            type: String,
            required: true,
        }
    },

    methods:
    {
        /**
         * Select all members
         */
        selectAll()
        {
            this.$emit('updateSelection', _.map(this.collection, this.identifier));
        },

        /**
         * Select no members
         */
        selectNone()
        {
            this.$emit('updateSelection', []);
        },

        /**
         * Wrapper for lodash _.size
         */
        count(collection)
        {
            return _.size(collection);
        },
    },
}
</script>



// WEBPACK FOOTER //
// Selection.vue?37432806